'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SpruceClassName = require('../util/SpruceClassName');

var _SpruceClassName2 = _interopRequireDefault(_SpruceClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @module Inputs
 */

/**
 * @component
 *
 * `Toggle` is a simple input component that works like a checkbox.
 * Its value is a boolean. It defaults to `false`.
 *
 * @example
 * return <Toggle
 *    value={yourBoolean}
 *    onChange={(value) => doSomething(value)}
 * >Toggle text</Toggle>
 *
 * @category ControlledComponent
 */

var Toggle = function (_React$Component) {
    (0, _inherits3.default)(Toggle, _React$Component);

    function Toggle() {
        (0, _classCallCheck3.default)(this, Toggle);
        return (0, _possibleConstructorReturn3.default)(this, (Toggle.__proto__ || (0, _getPrototypeOf2.default)(Toggle)).apply(this, arguments));
    }

    (0, _createClass3.default)(Toggle, [{
        key: 'render',
        value: function render() {
            var _additionalClassNames;

            var _props = this.props,
                children = _props.children,
                className = _props.className,
                disabled = _props.disabled,
                modifier = _props.modifier,
                onChange = _props.onChange,
                peer = _props.peer,
                spruceName = _props.spruceName,
                style = _props.style,
                toggleProps = _props.toggleProps,
                value = _props.value;


            var additionalClassNames = (_additionalClassNames = {}, (0, _defineProperty3.default)(_additionalClassNames, spruceName + '-active', !!value), (0, _defineProperty3.default)(_additionalClassNames, spruceName + '-disabled', disabled), _additionalClassNames);

            return _react2.default.createElement('button', (0, _extends3.default)({}, toggleProps, {
                className: (0, _SpruceClassName2.default)({ name: spruceName, modifier: modifier, className: className, peer: peer }, additionalClassNames),
                disabled: disabled,
                onClick: function onClick(ee) {
                    return !disabled && onChange && onChange(!value, { event: ee, element: ee.target });
                },
                type: 'button',
                children: children,
                style: style
            }));
        }
    }]);
    return Toggle;
}(_react2.default.Component);

Toggle.defaultProps = {
    className: '',
    disabled: false,
    modifier: '',
    peer: '',
    spruceName: 'Toggle',
    style: {},
    toggleProps: {},
    value: false
};
exports.default = Toggle;


//////////////////
// WEBPACK FOOTER
// ./~/stampy/lib/component/Toggle.js
// module id = 154
// module chunks = 35783957827783 114276838955818 162898551421021